<div class="home-screen full-width text-center">
  <h1>Welcome to the DWM <br />(Database Warranty Management)</h1>

  <div class="links flex-row-wrap justify-center items-center">
    @if (featureTypes.includes(FeatureType.Complaints)) {
    <button routerLink="/parts-table" class="card flex-column justify-center items-center">
      <div class="img-wrap">
        <img src="../../../assets/images/parts.png" alt="Parts">
      </div>
      <p>Parts Table (Parts)</p>
    </button>
    }
    @if (featureTypes.includes(FeatureType.Claims)) {
    <button routerLink="/claims-table" class="card flex-column justify-center items-center">
      <div class="img-wrap">
        <img src="../../../assets/images/claim-icon.png" alt="Claims">
      </div>
      <p>Claims Table (Claims)</p>
    </button>
    }
    @if (featureTypes.includes(FeatureType.Complaints0Km) && isComplaint0KmEnabled) {
    <button routerLink="/issues-table" class="card flex-column justify-center items-center">
      <div class="img-wrap">
        <img src="../../../assets/images/0km-icon.png" alt="Issue">
      </div>
      <p>0km Issue Table (Issue)</p>
    </button>
    }
    @if (featureTypes.includes(FeatureType.Documents)) {
    <button routerLink="/document-management" class="card flex-column justify-center items-center">
      <div class="img-wrap">
        <img src="../../../assets/images/doc-mng.png" alt="Document Management">
      </div>
      <p>Document Management</p>
    </button>
    }
    @if (featureTypes.includes(FeatureType.KpiScorecards)) {
    <button routerLink="/kpi-scorecards" class="card flex-column justify-center items-center">
      <div class="img-wrap">
        <img src="../../../assets/images/kpi-scorecards.png" alt="KPI Scorecards">
      </div>
      <p>KPI Scorecards</p>
    </button>
    }
    @if (isPocFormEnabled) {
    <button routerLink="/poc" class="card flex-column justify-center items-center">
      <div class="img-wrap">
        <img src="../../../assets/images/poc-warranty.png" alt="PoC">
      </div>
      <p>PoC</p>
    </button>
    }
    @if (featureTypes.includes(FeatureType.CommonCharts)) {
    <button routerLink="/common-charts" class="card flex-column justify-center items-center">
      <div class="img-wrap">
        <img src="../../../assets/images/claim-icon.png" alt="Common Charts">
      </div>
      <p>Common Charts</p>
    </button>
    }
  </div>
</div>